import styled, { css } from 'styled-components';
import Colours from '/shared/styled/Colours';
import { baseFontWeight } from '/shared/styled/GlobalStyle/GlobalStyle';

interface Props {
  $inline?: boolean;
  $isErrored?: boolean;
  $hasDropdown?: boolean;
  $dropdownSingleNoBorder?: boolean;
  $hasDropdownFirst?: boolean;
  disabled?: boolean;
  $highlight?: boolean;
}

function inlineStyle({ $inline }: Props) {
  if ($inline) {
    return css`
      display: inline-block;
      min-width: auto;
      width: auto;
    `;
  }
}

function isErroredStyle({ $isErrored }: Props) {
  if ($isErrored) {
    return css`
      border-color: ${Colours.redLight5};
      z-index: 2;
    `;
  }
}

function disabledStyle({ disabled = false }: Props) {
  if (disabled) {
    return css`
      border-color: ${Colours.greyLight6};
      background: ${Colours.whiteDark1};
      color: ${Colours.greyLight1};
      opacity: 0.8;
      cursor: not-allowed;

      &::-webkit-input-placeholder {
        color: ${Colours.greyLight1} !important;
      }

      &:-ms-input-placeholder {
        color: ${Colours.greyLight1} !important;
      }
    `;
  }
}

function hasDropdownStyle({ $hasDropdown, $dropdownSingleNoBorder = false, $hasDropdownFirst }: Props) {
  if ($hasDropdown && $dropdownSingleNoBorder === false && $hasDropdownFirst) {
    return css`
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    `;
  }
  if ($hasDropdown && $dropdownSingleNoBorder === false) {
    return css`
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    `;
  }
}

function highlightStyle({ $highlight }: Props) {
  if ($highlight) {
    return css`
      border-color: ${Colours.green};
    `;
  }
}

export default styled.input<Props>`
  display: block;
  background: ${Colours.white};
  border-radius: 1.25rem;
  padding: 0.6667rem 1.25rem;
  line-height: 1;
  appearance: none;
  border: 1px solid ${Colours.greyLight2};
  width: 100%;
  font-weight: 400;
  font-size: 0.933333rem;

  &[type=password] {
    ${baseFontWeight}
  }

  color: inherit;

  &::-webkit-input-placeholder {
    line-height: normal;
    color: ${Colours.grey} !important;
  }

  &:-ms-input-placeholder {
    line-height: normal !important;
    color: ${Colours.grey} !important;
  }
  ${inlineStyle}
  ${isErroredStyle}
  ${hasDropdownStyle}
  ${disabledStyle}
  ${highlightStyle}
`;
